var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPolarisAssistInactive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4157 16L16 23L10 19.0587L15.4157 16Z",
    fill: "#8390AB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.9885 9L16.4262 13.5744C10.9653 16.9031 5.86193 20.0207 0.99685 23L6.06359 14.3549L0 9C8.00229 9.02496 15.9725 9.02496 24 9H23.9885ZM3.31596 10.2502C9.68662 11.1851 19.2082 10.6768 4.60155 19.3264C8.00687 17.2457 11.7697 14.9585 15.7708 12.5011L19.5016 10.2525C14.0903 10.2767 8.69512 10.2767 3.31596 10.2525V10.2502Z",
    fill: "#8390AB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4591 0L15 8H10L14.4591 0Z",
    fill: "#8390AB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolarisAssistInactive);
export default __webpack_public_path__ + "static/media/Polaris-Assist-inactive.6f47205ab16dcfb13d17862d2b3ae836.svg";
export { ForwardRef as ReactComponent };